export default function getMappingManager({ mapping, setMapping, fields, defaultMappingOptions, featuresByPostType, config }) {


	const isOptionAvailable = (value) => {
		let available = false;

		let postType = config.post_type;
		if (postType === 'custom') {
			const newPostType = config.post_type_slug;
			if (newPostType && featuresByPostType.hasOwnProperty(newPostType)) {
				postType = newPostType;
			}
		}

		const group = value.substring(0, value.indexOf('::'));
		const feature = value.substring(value.indexOf('::') + 2);

		// Check if feature is available for post type
		if (featuresByPostType.hasOwnProperty(postType) && featuresByPostType[postType].hasOwnProperty(group) && Array.isArray(featuresByPostType[postType][group])) {
			available = featuresByPostType[postType][group].indexOf(feature) > -1;
		}

		return available;
	};

	const isOptionDisabled = (option) => {
		if (option.allow_multiple) {
			return false;
		}
		return mapping.reduce(function(result, current) {
			return current.wordpress && current.wordpress === option.value ? true : result;
		}, false);
	}


	const notionFieldsOptions = fields.reduce(function (result, field) {
		if (!result[field.group]) {
			result[field.group] = {
				label: field.group,
				options: []
			};
		}
		result[field.group].options.push(field);
		return result;
	}, {});

	const wordPressFieldsOptions = mapping.map((field) => {
		const mappingOptions = {};
		const notionField = getNotionFieldById(field.notion, fields);

		// Filter options by post type
		for (const groupName in defaultMappingOptions) {
			const group = defaultMappingOptions[groupName];
			const groupOptions = group.options.filter(function(option) {
				return isOptionAvailable(option.value);
			});
			if (groupOptions.length > 0) {
				mappingOptions[groupName] = { ...group, options: groupOptions };
			}
		}

		// Filter options by supported types
		let notionType = notionField ? notionField.type : '';
		// Use result type for computed fields (formula, lookup)
		if (notionField && notionField.options && notionField.options.result && notionField.options.result.type ) {
			notionType = notionField.options.result.type;
		}
		for (const groupName in mappingOptions) {
			const group = mappingOptions[groupName];
			group.options = group.options.filter(function(option) {
				return option.supported_sources.indexOf(notionType) > -1
			});
			if (group.options.length === 0) {
				delete mappingOptions[groupName];
			}
		}

		const rowValue = field.wordpress ?? null;

		// Check if some options must be disabled
		for (const groupName in mappingOptions) {
			const group = mappingOptions[groupName];
			group.options = group.options.map(function(option) {
				return {
					...option,
					enabled: option.enabled && (option.value === rowValue || !isOptionDisabled(option))
				};
			});
		}

		return mappingOptions;
	});

	const getNotionFirstOption = () => {
		return fields.length > 0 ? fields[0].id : '';
	};

	const addMappingRow = () => {
		const notionFirstOption = getNotionFirstOption();

		setMapping([
			...mapping,
			{
				notion: notionFirstOption,
				wordpress: '',
				options: {}
			}
		]);
	};

	const updateNotionField = (index, notionFieldId) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					notion: notionFieldId
				};
			}
			return el;
		}));
	};
	const updateWordPressField = (index, wordPressFieldId) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					wordpress: wordPressFieldId
				};
			}
			return el;
		}));
	};
	const updateFieldOption = (index, optionName, optionValue) => {
		setMapping(mapping.map((el, i) => {
			if (i === index) {
				return {
					...el,
					options: {
						...el.options,
						[optionName]: optionValue
					}
				};
			}
			return el;
		}));
	};
	const removeMappingRow = (index) => {
		setMapping(mapping.filter((el, i) => i !== index));
	};

	return { notionFieldsOptions, wordPressFieldsOptions, addMappingRow, updateNotionField, updateWordPressField, updateFieldOption, removeMappingRow };
}

const getNotionFieldById = (notionId, fields) => {
	return fields.find(function(field) {
		return field.id === notionId;
	});
};

/**
 * Filter out invalid mapping fields.
 *
 * @param mapping
 * @param fields
 * @returns {*}
 */
export function sanitizeMapping(mapping, fields) {
	return mapping.filter((field) => {
		return !!getNotionFieldById(field.notion, fields);
	})
}
